import { stripeApi } from "@/service/client";
import { useQuery } from "@tanstack/react-query";
import { usePathname } from "next/navigation";

const ignorePages = ["/", "/contact", "/features"];

export const useSubscriptionController = () => {
  const pathname = usePathname();

  const { data: subscription, isLoading } = useQuery({
    queryKey: ["subscription"],
    queryFn: () => stripeApi.getSubscription(),
    enabled: !ignorePages.includes(pathname),
  });

  const createSubscription = async () => {
    const url = await stripeApi.createSubscription();
    window.location.href = url;
  };

  const manageSubscription = async () => {
    const url = await stripeApi.manageSubscription();
    window.location.href = url;
  };

  const active =
    subscription?.status === "active" || subscription?.status === "trialing";

  return {
    subscription,
    isLoading,
    createSubscription,
    manageSubscription,
    active,
  };
};
